/*
 * A number (usually an epoch-ms timestamp) kept in sessionStorage. Storage can be blocked (private
 * mode, storage disabled): reads then come back undefined and writes are dropped, never thrown.
 */

/** The stored number, or undefined when nothing readable is stored. */
export function readSessionNumber(key: string): number | undefined {
    try {
        const value = Number(sessionStorage.getItem(key) ?? Number.NaN);
        return Number.isFinite(value) ? value : undefined;
    } catch {
        return undefined;
    }
}

export function writeSessionNumber(key: string, value: number): void {
    try {
        sessionStorage.setItem(key, String(value));
    } catch {
        // Storage blocked: dropped, so the next read sees nothing.
    }
}

export function removeSessionItem(key: string): void {
    try {
        sessionStorage.removeItem(key);
    } catch {
        // Storage blocked: nothing to remove.
    }
}
